import { CommandDispatcher } from "../../shared/domain/CommandDispatcher";

export class ActivateFacturaeClientTrialCommand {
  constructor(
    private readonly dispatcher: CommandDispatcher,
  ) {}

  run(company_id): Promise<{ [key: string]: string; }> {
    let args = {
      company_id:company_id, 
      client:true
    }
    return this.dispatcher.dispatch('activate.user.trial.facturae', args)
  }
}